import { setCssVar } from 'quasar'
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
import { Platform } from 'quasar'

export function SAVE_PARAMS(state, [login, clients, register, user_profile, languages, attempts, layout]){
    state.login = login
    state.clients = clients
    state.register = register
    state.user_profile = user_profile
    state.languages = languages
    state.attempts = attempts
    state.layout = layout

    if (Platform.is.ios) {
        Storage.set({ key: 'login', value: JSON.stringify(login) })
        Storage.set({ key: 'clients', value: JSON.stringify(clients) })
        Storage.set({ key: 'register', value: JSON.stringify(register) })
        Storage.set({ key: 'user_profile', value: JSON.stringify(user_profile) })
        Storage.set({ key: 'languages', value: JSON.stringify(languages) })
        Storage.set({ key: 'attempts', value: JSON.stringify(attempts) })
        Storage.set({ key: 'layout', value: JSON.stringify(layout) })
    }

    setCssVar('primary', login.colors.primary)
    setCssVar('secondary', login.colors.secondary)
    setCssVar('accent', login.colors.tertiary)
}

export function SAVE_ATTEMPTS(state, [attempts]){
    state.attempts = attempts
}